// menuPublicApi.js
import apiClient, { constr_uri } from '../../services/apiClient';

const withQuery = (base, params = {}) => {
  const query = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== '')
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join('&');
  return query ? `${base}?${query}` : base;
};

export const menuPublicApi = {
  // Public, unauthenticated endpoint — no portions/dishIds, just what's presentable.
  getDay: async (kindergartenId, date) => {
    const result = await apiClient.get(withQuery('kitchen/menu/public/day', { kindergartenId, date }));
    return result.data || { ageGroups: [] };
  },

  // photoUrl from the API is a relative docfile?doc_id=..&file_id=.. reference — build the full
  // URL the same way the rest of the app does for uploaded media (see NewsEditor's coverSrc).
  photoSrc: (photoUrl) => photoUrl ? constr_uri(photoUrl) : null
};

export default menuPublicApi;
